/* Ink band: the figures are the accent, reversed out of near-black. */
.money {
  padding: 84px 0;
  background: var(--color-primary-grey-900); /* PRIMARY_GREY_900 */
  color: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
}

/* Reversed out, so the head's own ink colours have to be overridden. The class is doubled to beat
   SectionHead's own selectors on specificity rather than relying on CSS emit order. */
.money__head.money__head h2 {
  color: var(--color-primary-sand-100); /* PRIMARY_SAND_100 */
}

.money__head.money__head p {
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
}

.money__head.money__head h2 span {
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
}

.money__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  border: 3px solid var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  border-radius: 22px;
  overflow: hidden;
}

.mn {
  padding: 44px 34px;
  border-right: 3px solid var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.mn:last-child {
  border-right: none;
}

.mn__num {
  font-family: var(--plume-font-display, sofia-pro, sans-serif);
  font-weight: 900;
  /* HACK: fluid display size — candidate future DS heading scale */
  font-size: clamp(38px, 4.6vw, 64px);
  line-height: 0.96;
  letter-spacing: -0.03em;
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  font-variant-numeric: tabular-nums;
}

.mn__body {
  font-size: 16px; /* COPY_M */
  line-height: 1.6;
  /* HACK: the design dims the cream over ink; no DS token for a translucent foreground. */
  color: rgba(246, 241, 235, 0.8);
  margin: 0;
}

.mn__body a {
  color: var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  text-decoration: underline;
  text-underline-offset: 3px;
}

@media (max-width: 1000px) {
  .money__grid {
    grid-template-columns: 1fr;
  }

  .mn {
    border-right: none;
    border-bottom: 3px solid var(--color-complementary-yellow); /* COMPLEMENTARY_YELLOW */
  }

  .mn:last-child {
    border-bottom: none;
  }
}

@media (max-width: 768px) {
  .money {
    padding: 56px 0;
  }
}
